export const videoExists = (url: string): Promise<boolean> =>
    new Promise<boolean>((res) => {
        const video = document.createElement("video");
        video.onloadedmetadata = () => res(true);
        video.onerror = () => res(false);
        video.src = url;
    });